<ng-container *ngIf="product$ | async as product" class="product-summary">
  <div  class="pdp-add-to-cart">
    <cx-add-to-cart
      [view]="view"
      [product]="product"
      [productCode]="product?.code"
      [showQuantity]="true"
    ></cx-add-to-cart>
  </div>
  
  <a 
    class="favorite-section"
    *ngIf="
      (user$ | async) && (product?.sellabilityFlag || product?.quotabilityFlag) 
    "
    (click)="onFavoriteClick(product)"
  >
    <em class="material-icons overlay-fav-icon">{{
      favStatus ? "star" : "star_border"
    }}</em>
    <span class="overlay-fav-txt">
      {{
        favStatus ? "Remove from Favorite List" : "Add to Favorite List"
      }}</span
    >
  </a>
  <br>
<!-- <div class="tabletext">
 <table class="table-pdptable">
   <thead>
     <tr class="table-pdp">
       <th>Other available locations</th>
       <th>No. of units available</th>
    </tr>
  </thead>
<tbody>
 <tr *ngFor="let entity of shippedFrmOptions">
                        <td>{{ entity.name }}</td>
                      <td>{{
                          entity?.stockAvailable || 0 | number: "1.0-0"
                        }}</td>
                    </tr> 
  </tbody>
</table>
</div>
<div class="buycheckpdp"><p class="pdp-checkprice">Want to buy from another site? </p></div>
<div class="row">
  <div class="cx-dialog-info col-md-5">
      <div class="inventory-text"><span>Top right, click “Change Account”, “Change Legal Entity” to buy from another site if  your account allows.</span></div>
  </div>
  <div class="col-md-2">
      <div ><img
          src="../../../../../assets/img/orImg.svg"
          alt="OR"
        /></div>
  </div>
  <div class="cx-dialog-info col-md-5 pl-0">
      <div class="inventory-text"><span>Place Order or Quote and comment to CSR that material is available at another site.</span></div>
  </div>
</div> -->
</ng-container>
